import { render } from "./ExitButton.vue?vue&type=template&id=429c3d64&scoped=true&ts=true"
import script from "./ExitButton.vue?vue&type=script&lang=ts"
export * from "./ExitButton.vue?vue&type=script&lang=ts"

import "./ExitButton.vue?vue&type=style&index=0&id=429c3d64&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429c3d64"]])

export default __exports__